import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { CartService } from 'app/cart/cart.service';
import { SharedService } from 'app/shared.service';
import { ModalService } from 'app/modal/modal.service';
import * as moment from 'moment';

@Component({
    selector: 'app-summary-conf',
    templateUrl: './summary.component.html',
    styleUrls: ['./summary.component.scss']
})
export class SummaryConfComponent implements OnInit {
    @HostBinding('class.conf-summary--fixed') isFixed: Boolean = false;

    public ticketPrice: number = 0;
    public maxGain: number = 0;
    public odds: number = 0;
    public backPay: number = 0;
    public serviceFee: number = 0;
    public pension: Boolean = false;
    public environment: string;
    public products = [];
    public env: String = this.sharedService.getEnvironment();
    public isLoggedIn: boolean;
    public lotteryNumber = null;
    public lotteryStartDate = null;

    @Input()
    productScopeId;

    constructor(
        private cartService: CartService,
        private sharedService: SharedService,
        private modalService: ModalService
    ) {
        this.pension =
            sharedService.getLotterySource() === 'pension' ? true : false;
        this.environment = this.sharedService.getEnvironment();
    }

    ngOnInit() {
        /*
         * Subscribes the EventEmitter from
         * CartService and updates local properties
         * if values have changed.
         */
        this.cartService.cartUpdated.subscribe((calculatedProduct) => {
            this.products = calculatedProduct.products;
            this.ticketPrice = calculatedProduct.stake;
            this.maxGain = calculatedProduct.maxGain;
            this.serviceFee = calculatedProduct.lottery.serviceFee;
            this.odds = calculatedProduct.odds || 0;
            this.backPay = calculatedProduct.backPay || 0;

            const startDate = moment(calculatedProduct.lottery.start);
            this.lotteryNumber = this.cartService.getLotteryNumber();
            this.lotteryStartDate = startDate.format('DD.MM.YYYY');

            if (this.ticketPrice > 0) {
                this.isFixed = true;
            } else {
                this.isFixed = false;
            }
        });

        this.sharedService.loggedIn.subscribe((response) => {
            this.isLoggedIn = response;
        });
    }

    goToCheckout(): void {
        if (this.productScopeId !== undefined) {
            this.cartService.filterProductsByScopeId(this.productScopeId);
        }
        if (this.products.length === 0) {
            this.modalService.openModal('emptyCart');
        } else if (this.ticketPrice + this.backPay > 150 && !this.isLoggedIn) {
            this.modalService.openModal('notLoggedIn');
        } else {
            this.sharedService.pushCustomToDataLayer({
                event: 'add_to_cart',
                ecommerce: {
                    currency: 'EUR',
                    value: this.cartService.getTotalPriceWithoutDiscount(),
                    items: this.cartService.getProductsForGTMTracking()
                }
            });
            window.location.href =
                this.env === 'skl'
                    ? '/skl-los-anfordern/#/bestellen'
                    : '/nkl-los-anfordern/#/bestellen';
        }
    }

    getTooltipText() {
        const text = `Die ${this.lotteryNumber}. Lotterie hat bereits am ${this.lotteryStartDate} begonnen. Sie haben noch die Möglichkeit in die laufende Lotterie einzusteigen. Für bereits abgelaufene Klassen müssen Sie Ihren Einsatz nachentrichten. Dies gilt nicht für die Joker Spiele.`;
        return text;
    }
}
